module.exports = __webpack_public_path__ + "static/media/markericon.cd5195f9.ico";